
import FiltroProfesiones from '@/model/filtros/FiltroProfesiones';
import { Options, Vue } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { agrupacionesStore } from '@/store/AgrupacionesStore';
import Agrupacion from '@/model/Agrupacion';

@Options({
  components: {},
  name: 'FiltrosProfesiones',
})
export default class FiltrosProfesiones extends Vue {
  async mounted() {
    if (agrupacionesStore.getState().length === 0) {
      agrupacionesStore.loadAgrupaciones();
    }
  }

  @Prop()
  private filtro!: FiltroProfesiones;

  private agrupaciones: Agrupacion[] = agrupacionesStore.getState();

  form(): Vue & { validate: () => boolean; resetValidation(): void } {
    return this.$refs.form as Vue & {
      validate: () => boolean;
      resetValidation(): void;
    };
  }

  validate() {
    return this.form().validate();
  }
  filterFn(val: string, update: (arg0: { (): void; (): void }) => void) {
    if (val === '') {
      update(() => {
        this.agrupaciones = agrupacionesStore.getState();
      });
      return;
    }

    update(() => {
      const needle = val.toUpperCase();
      this.agrupaciones = agrupacionesStore.getState().filter((v) => v.descripcion.toUpperCase().indexOf(needle) > -1);
    });
  }

  resetValidation() {
    this.form().resetValidation();
  }
}
